'use strict';

var React = require('react');

const I18nContext = /*#__PURE__*/React.createContext(undefined);

exports.I18nContext = I18nContext;
